import { AutoFocusDirective } from './autoFocus.directive';

// @ts-ignore
export const directives = [AutoFocusDirective];

export * from './autoFocus.directive';
